import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/loading.png'


const _withScopeId = n => (_pushScopeId("data-v-4cdeeb02"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  src: _imports_0
}

import { computed, ref, nextTick } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Boolean,
    required: false,
    default: null,
  },
  src: {
    type: String,
    required: false,
    default: null,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props

const loading = ref<HTMLElement>();

const enablePropSrc = computed(() => {
  return typeof props.src === "string" && props.src !== "";
});
const enableDefaultSrc = computed(() => {
  return typeof props.src !== "string";
});

const internalValue = ref(false);
const isLoading = computed({
  get() {
    const iv = internalValue.value;
    const modelValue =
      typeof props.modelValue === "boolean" ? props.modelValue : iv;
    if (modelValue) focus();
    else unfocus();
    return modelValue;
  },
  set(value: boolean) {
    internalValue.value = value;
    emit("update:modelValue", value);
  },
});
let focusElement: HTMLElement | null = null;
/**
 * カレントの要素にフォーカスを当てる
 */
async function focus() {
  focusElement = document.activeElement as HTMLElement;
  console.debug("backup focus element :%o", focusElement);
  await nextTick();
  const _loading = loading.value;
  _loading?.focus();
}
async function unfocus() {
  try {
    if (focusElement && focusElement !== document.body) {
      if (document.body.contains(focusElement)) {
        focusElement.focus();
        console.debug("restore forcus:%o", focusElement);
      }
    }
  } finally {
    focusElement = null;
  }
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "loading_back",
    tabindex: "0",
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["tab"])),
    ref_key: "loading",
    ref: loading
  }, [
    (_unref(enablePropSrc))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: props.src
        }, null, 8, _hoisted_1))
      : (_unref(enableDefaultSrc))
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true)
  ], 544)), [
    [_vShow, _unref(isLoading)]
  ])
}
}

})